module.exports = __webpack_public_path__ + "img/automation1.263e3771.png";